var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.335A4.663 4.663 0 003.333 6c0 3.5 4.667 8.667 4.667 8.667S12.666 9.5 12.666 6A4.663 4.663 0 008 1.335zM4.666 6a3.335 3.335 0 016.667 0c0 1.92-1.92 4.794-3.333 6.587C6.613 10.808 4.666 7.9 4.666 6z",
    fill: "var(--icon-dark-gray)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.668a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333z",
    fill: "var(--icon-dark-gray)"
  })));
}
export default SvgAddress;